export default "__VITE_ASSET__CJYacACR__"